import { Box } from '@mui/material';

export const TableFallbackIcon = () => (
  <Box display='grid' gridTemplateRows='4fr 3fr 2fr 1fr' width='100%' height='100%' gap='3px'>
    <Box
      height='100%'
      width='100%'
      sx={{ backgroundColor: 'baseColors.deepSeaNavy.c100' }}
      borderRadius='2px'
    />
    <Box display='flex' justifyContent='center'>
      <Box
        height='100%'
        width='90%'
        sx={{ backgroundColor: 'baseColors.gray.c100', opacity: 0.95 }}
        borderRadius='2px'
      />
    </Box>
    <Box display='flex' justifyContent='center'>
      <Box
        height='100%'
        width='80%'
        sx={{ backgroundColor: 'baseColors.gray.c100', opacity: 0.9 }}
        borderRadius='2px'
      />
    </Box>
    <Box display='flex' justifyContent='center'>
      <Box
        height='100%'
        width='70%'
        sx={{ backgroundColor: 'baseColors.gray.c100', opacity: 0.8 }}
        borderRadius='2px'
      />
    </Box>
  </Box>
);
